// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teachers-name{
    color: rgba(57, 57, 57, 1);
    font-size: 12px;
}
.stbox-before{
    position: relative;
    overflow: hidden;
}
.stbox-before::before{
    position: absolute;
    content: "";
    width: 4px;
    height: 100%;
    top: 0px;
    right: 0;
    background-color: rgba(114, 194, 234, 1);
    
}`, "",{"version":3,"sources":["webpack://./src/styles/score.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,QAAQ;IACR,wCAAwC;;AAE5C","sourcesContent":[".teachers-name{\n    color: rgba(57, 57, 57, 1);\n    font-size: 12px;\n}\n.stbox-before{\n    position: relative;\n    overflow: hidden;\n}\n.stbox-before::before{\n    position: absolute;\n    content: \"\";\n    width: 4px;\n    height: 100%;\n    top: 0px;\n    right: 0;\n    background-color: rgba(114, 194, 234, 1);\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
